import {
    Translation,
    translocoConfig,
    TranslocoModule,
    TranslocoService,
    provideTransloco
} from '@ngneat/transloco';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {environment} from 'environments/environment';
import {TranslocoHttpLoader} from 'app/core/transloco/transloco.http-loader';

@NgModule({
    exports: [
        TranslocoModule
    ],
    providers: [
        provideTransloco({
            config: translocoConfig({
                availableLangs: [
                    {
                        id: 'es',
                        label: 'Spanish'
                    },
                    {
                        id: 'en',
                        label: 'English'
                    }],
                defaultLang: 'es',
                fallbackLang: 'es',
                reRenderOnLangChange: true,
                prodMode: environment.production
            }),
            loader: TranslocoHttpLoader
        }),
        {
            // Preload the default language before the app starts to prevent empty/jumping content
            provide: APP_INITIALIZER,
            deps: [TranslocoService],
            useFactory: (translocoService: TranslocoService): any => (): Promise<Translation> => {
                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);
                return translocoService.load(defaultLang).toPromise();
            },
            multi: true
        }
    ]
})
export class TranslocoCoreModule {
}
